enum CaptchaEvent {
    READY = 'captcha:ready',
    EXECUTE = 'captcha:execute',
    SUCCESS = 'captcha:success',
    ERROR = 'captcha:error',
    EXPIRE = 'captcha:expire'
}

export default CaptchaEvent;
